module.exports = __webpack_public_path__ + "img/companyLogo.b8275d02.png";